import { render, staticRenderFns } from "./BAlertRegimeNonSalaries.vue?vue&type=template&id=9a0a6d0a&"
import script from "./BAlertRegimeNonSalaries.vue?vue&type=script&lang=js&"
export * from "./BAlertRegimeNonSalaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports